module.exports = __webpack_public_path__ + "media/review-badges/rank-75k-00443878.svg";